import React, { useEffect, useState } from 'react';

import { Button } from '../ButtonElement';
import pdf from "../../resume/IshTakkar_Resume_Fall_2022_3.pdf";
import { InfoContainer, InfoWrapper, InfoRow, Column1, Column2, TextWrapper, TopLine, Heading, Subtitle, BtnWrap, ImgWrap, Img, ButtonRedirect, BtnWrap2 } from './InfoElements';

const Info = ({ lightBg, imgStart, id, topLine, lightText, darkText, headline, description, buttonLabel, img, alt, primary, dark, dark2, multiple, to }) => {

    // const [shouldShow, setShouldShow] = useState(true);
    // const [lastYPos, setLastYPos] = useState(0);

    // useEffect(() => {

    //     const handleScroll = () => {
    //         const yPos = window.scrollY;
    //         const isScrollingUp = yPos < lastYPos;
    //         setShouldShow(isScrollingUp);
    //         setLastYPos(yPos);
    //     }

    //     window.addEventListener('scroll', handleScroll, false);

    //     return () => {
    //         window.removeEventListener('scroll', handleScroll, false);
    //     }
    // }, [lastYPos]);

    return (
      <>
        <InfoContainer lightBg={lightBg} id={id}>
          <InfoWrapper>
            <InfoRow imgStart={imgStart}>
              <Column1>
                <TextWrapper>
                  <TopLine>{topLine}</TopLine>
                  <Heading lightText={lightText}>{headline}</Heading>
                  <Subtitle
                    // initial={{ opacity: 0, scale: 0.5 }}
                    // animate={{ opacity: shouldShow ? 0 : 1, scale: shouldShow ? 0.5 : 1 }}
                    // transition={{duration: 1}}
                    darkText={darkText}
                  >
                    {description.replace("<br/>", "\n")}
                  </Subtitle>
                  <BtnWrap>
                    {!multiple ? (
                      <Button
                        to={to}
                        smooth={true}
                        duration={500}
                        spy={true}
                        exact="true"
                        offset={-80}
                        primary={primary ? 1 : 0}
                        dark={dark ? 1 : 0}
                        dark2={dark2 ? 1 : 0}
                      >
                        {buttonLabel}
                      </Button>
                    ) : (
                      <BtnWrap2>
                        <ButtonRedirect
                          href="mailto:ishtakkar21@gmail.com"
                          target="_blank"
                          primary={primary ? 1 : 0}
                          dark={dark ? 1 : 0}
                          dark2={dark2 ? 1 : 0}
                        >
                          E-mail
                        </ButtonRedirect>
                        <ButtonRedirect
                          href="https://github.com/IshTakkar"
                          target="_blank"
                          primary={primary ? 1 : 0}
                          dark={dark ? 1 : 0}
                          dark2={dark2 ? 1 : 0}
                        >
                          Github
                        </ButtonRedirect>
                        <ButtonRedirect
                          href="https://www.linkedin.com/in/ish-takkar-486965192/"
                          target="_blank"
                          primary={primary ? 1 : 0}
                          dark={dark ? 1 : 0}
                          dark2={dark2 ? 1 : 0}
                        >
                          LinkedIn
                        </ButtonRedirect>
                        <ButtonRedirect
                          href={pdf}
                          without
                          rel="noopener noreferrer"
                          target="_blank"
                          primary={primary ? 1 : 0}
                          dark={dark ? 1 : 0}
                          dark2={dark2 ? 1 : 0}
                        >
                          Resume
                        </ButtonRedirect>
                      </BtnWrap2>
                    )}
                  </BtnWrap>
                </TextWrapper>
              </Column1>
              <Column2>
                <ImgWrap>
                  <Img src={img} alt={alt} />
                </ImgWrap>
              </Column2>
            </InfoRow>
          </InfoWrapper>
        </InfoContainer>
      </>
    );
}

export default Info;